import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { DataService } from "src/app/services/data.service";

@Component({
  selector: "app-subscription",
  templateUrl: "./subscription.component.html",
  styleUrls: ["./subscription.component.scss"],
})
export class SubscriptionComponent implements OnInit {
  user: any = {};
  constructor(private dataService: DataService, private title: Title, private router: Router) {}

  ngOnInit(): void {
    this.dataService.userDetails();
    this.user = this.dataService.userDetail;
    this.title.setTitle(`Subscription | Illusbook`);
    if(!this.user || !this.user.id) {
      this.router.navigate(["/"]);
      return;
    }
  }
}
